/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import addressTranslations from "./addressTranslations";

const organizationTranslations = {
  name: {
    label: "Name",
  },
  legalName: {
    label: "Firma",
    question: "Wie lautet der Name des Unternehmens?",
  },
  email: {
    label: "E-Mail-Adresse",
  },
  telephone: {
    label: "Telefonnummer",
  },
  fax: {
    label: "Faxnummer",
  },
  beaSafeId: {
    label: "beA-Adresse",
  },
  address: addressTranslations,
}

export default organizationTranslations;
